<template>

  <div>

    <div class="content-header">

      <div class="content-header-inner">

        <h1 class="content-header-title">404: Page not found</h1>

        <p>Sorry this page could not be found</p>

      </div>

    </div>

  </div>

</template>

<script>
export default {
    name: 'NotFound',
    data() {
        return {
            
        }
    },
    created () {

        
    },
    methods: {
        
    },
    computed: {
        
    }
}
</script>